import { BreadcrumbsItem, BreadcrumbsStateless } from "@atlaskit/breadcrumbs";
// @material-ui/core
import { Typography } from "@material-ui/core";
// @material-ui/styles
import { withStyles } from "@material-ui/core/styles";
import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";
import { withRouter } from "react-router";
import { compose } from "redux";
import "./Location.css";

const styles = theme => ({
  color: {
    color: theme.palette.primary.contrastText,
    alignSelf: "center"
  }
});

// A simple component that shows the pathname of the current location
class ShowLocation extends React.Component {
  static propTypes = {
    match: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired
  };

  render() {
    const { location, classes } = this.props;
    let title =
      location.pathname.charAt(1).toUpperCase() + location.pathname.substr(2);
    let slugs = title.split("/");
    if (location.pathname.length === 1) {
      title = "";
    }

    return (
      <div className="keep-white">
        <BreadcrumbsStateless isExpanded={true}>
          {slugs.map((slug, index) => {
            return (
              <BreadcrumbsItem
                text={slug}
                hasSeperator={true}
                component={props => (
                  <Typography
                    variant="body2"
                    color="inherit"
                    component="span"
                    className={classNames(classes.color)}>
                    {slug}
                  </Typography>
                )}
                key={index}
              />
            );
          })}
        </BreadcrumbsStateless>
      </div>
    );
  }
}

export default compose(withRouter, withStyles(styles, { withTheme: true }))(
  ShowLocation
);



// WEBPACK FOOTER //
// ./src/library/helper/Location.js